import { TableDataType } from '../types/invoice.types';

export const COLUMN_HEADERS = {
  billNumber: 'Bill Number',
  billDate: 'Bill Date',
  clientCode: 'Client Code',
  clientName: 'Client Name',
  matterCategoryCode: 'Matter Category',
  clientMatterCode: 'Client Matter Code',
  matterName: 'Matter Name',
  delete: 'Delete',
} as const;

export const TABLE_COLUMNS: Array<{
  key: keyof TableDataType;
  header: string;
  sortable: boolean;
}> = [
  { key: 'billNumber', header: COLUMN_HEADERS.billNumber, sortable: true },
  { key: 'billDate', header: COLUMN_HEADERS.billDate, sortable: true },
  { key: 'clientCode', header: COLUMN_HEADERS.clientCode, sortable: true },
  { key: 'clientName', header: COLUMN_HEADERS.clientName, sortable: true },
  {
    key: 'matterCategoryCode',
    header: COLUMN_HEADERS.matterCategoryCode,
    sortable: true,
  },
  {
    key: 'clientMatterCode',
    header: COLUMN_HEADERS.clientMatterCode,
    sortable: true,
  },
  { key: 'matterName', header: COLUMN_HEADERS.matterName, sortable: true },
  {
    key: 'documents',
    header: 'Documents',
    sortable: false,
  },
];
